import { ReactElement, useEffect } from "react";
import { ICallOffsResult, IPanelProps } from "./types";
import RowComponent from "../../components/rowComponent";
import TextField from "@mui/material/TextField";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { cloneObject } from "../../../../system/utils";


const CallOffsPanel = ({ value, property, onChange }: IPanelProps<ICallOffsResult>): ReactElement => {

  useEffect(() => {
    if (!value) {
      onChange(property, {
        incidents: { value: false, comment: "" }
      });
    }
  }, [value]);

  const handleValue = (prop: keyof ICallOffsResult, selectedValue: any) => {
    const newValue = cloneObject(value);

    newValue[prop].value = selectedValue;
    onChange(property, newValue);
  };

  const onChangeComment = (prop: keyof ICallOffsResult, comment: string) => {
    const newValue = cloneObject(value);

    newValue[prop].comment = comment;
    onChange(property, newValue);
  };

  if (!value)  {
    return <div/>;
  }

  return (
    <div className="display-flex-column gap-1 p-1">
      <RowComponent title="Incidents" ratio={.2} >
        <div className="row-content-2 ">
          <ToggleButtonGroup
            fullWidth={true}
            value={value.incidents.value}
            exclusive={true}
            onChange={(_event, selectedValue) => handleValue("incidents", selectedValue)}>
            <ToggleButton value={true} >YES</ToggleButton>
            <ToggleButton value={false} >NO</ToggleButton>
          </ToggleButtonGroup>

          <TextField
            variant="outlined"
            placeholder="to be filled..."
            multiline={true}
            minRows={4}
            maxRows={4}
            value = {value.incidents.comment}
            fullWidth={true}
            onChange={event => onChangeComment("incidents", event.target.value)}
          />
        </div>
      </RowComponent>
    </div>
  );
};

export default CallOffsPanel;